/**
 * Mosaic entitlements — keep in sync with
 * `gaia-brooklyn-api/lib/services/stitched-transcript-playback/mosaic-entitlements.js`.
 */
import {
  ROLE_ID_EDITOR,
  ROLE_ID_EDITOR_PLUS,
  ROLE_ID_SITE_ADMIN,
  ROLE_ID_CUSTOMER_SERVICE,
  ROLE_ID_CUSTOMER_SERVICE_MANAGER,
  ROLE_ID_QA,
} from '../auth-access'

/** Subscription content_set_id values allowed to view persisted mosaics. */
export const MOSAIC_VIEW_SUBSCRIPTION_IDS = Object.freeze([253, 280, 290])

export const MOSAIC_CREATOR_ROLE_IDS = Object.freeze([
  ROLE_ID_EDITOR,
  ROLE_ID_EDITOR_PLUS,
  ROLE_ID_SITE_ADMIN,
  ROLE_ID_CUSTOMER_SERVICE,
  ROLE_ID_CUSTOMER_SERVICE_MANAGER,
  ROLE_ID_QA,
])
